import { defineComponent as f, Types as o } from "bitecs";
const i = f({
  offsetX: o.f32,
  offsetY: o.f32,
  offsetZ: o.f32,
  color: o.ui32,
  thickness: o.f32,
  opacity: o.f32,
  visible: o.ui8,
  arrowStart: o.ui8,
  arrowEnd: o.ui8,
  arrowSize: o.f32
});
export {
  i as Line
};
//# sourceMappingURL=components.js.map
